// extracted by mini-css-extract-plugin
module.exports = {"container":"EMLDisclaimer_container__3colE","table":"EMLDisclaimer_table__1BRCK"};